import React from 'react';

import './Button.css';

class Button extends React.Component {

	render() {
			let status = 0;
			if(this.props.index ===  this.props.active_index) {
				status = 1;
			}		
			return (
				<button 
					className = {"Button status-"+status}
					//className = {"Button "}
					onClick = 	{() => {
							this.props.button_handler(this.props.index) 
						}
					}
				>
				{this.props.name}
			</button> 
		)
	}
}

export default Button
